let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fDOGN")).then(() => parcelRequire('3I4fM'));